import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

// Define the response type for billing history item
export interface BillingHistoryItem {
  invoice_id: string;
  invoice_number: string;
  description: string;
  amount: number;
  currency: string;
  status: string;
  due_date: string;
  paid_at: string | null;
  payment_status: string;
  payment_method: string;
  created_at: string;
  payment_date: string;
  hosted_invoice_url: string | null;
  invoice_pdf: string | null;
}

// Define the response type
interface GetBillingHistoryResponse {
  meta: {
    error: boolean;
    code: number;
    message: string;
  };
  data: BillingHistoryItem[] | null;
}

export const getBillingHistory = async (store_id: string): Promise<GetBillingHistoryResponse> => {
  try {
    const response = await Axios.get(`/customer-subscription/billing-history?store_id=${store_id}`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      // Return the error response to handle it properly in the UI
      return error.response.data;
    }
    throw new Error(error.message || "Network Error");
  }
};

export const useGetBillingHistory = (store_id: string) => {
  return useQuery({
    queryKey: ["get-billing-history", store_id],
    queryFn: () => getBillingHistory(store_id),
    enabled: !!store_id, // Only run the query if store_id exists
  });
};